import React from 'react';
var Loading = function (_a) {
    var size = _a.size, color = _a.color, classNameSpinner = _a.classNameSpinner, className = _a.className, isNoneWidth = _a.isNoneWidth;
    return (React.createElement("div", { className: 'd-flex ' +
            (!isNoneWidth ? 'w-100' : '') +
            ' justify-content-center align-items-center ' +
            className },
        React.createElement("div", { className: 'gr-spinner-border ' +
                (size ? size : 'm ') +
                ' ' +
                (color ? color : 'primary ') +
                ' ' +
                (classNameSpinner ? classNameSpinner : ' ') })));
};
export { Loading };
//# sourceMappingURL=Loading.js.map